import { addSeconds } from "date-fns";
import { useEffect, useMemo, useState } from "react";

const getReturnValues = (countDown: number) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
};

export { useCountdown };

const useCountdown = (targetDate: Date) => {
  const countDownDate = new Date(targetDate).getTime();
  const [isExpired, setIsExpired] = useState(false);

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [countDownDate]);

  useEffect(() => {
    const { days, hours, minutes, seconds } = getReturnValues(countDown);
    if (days + hours + minutes + seconds <= 0) {
      setIsExpired(true);
    }
  }, [countDown]);

  return { ...getReturnValues(countDown), isExpired };
};

export const useCountdownFromNow = (durationInSeconds: number) => {
  const countDownDate = useMemo(
    () => addSeconds(new Date(), durationInSeconds),
    [durationInSeconds],
  );

  const countdown = useCountdown(countDownDate);

  return countdown;
};
